import download from 'downloadjs'

export default function (columns, rows) {
  var header = columns.map(function (c) { return '<td>'+c.label+'</td>' }).join('')
  var body = rows.map(function (row) {
    var data = columns.map(function (c) { return '<td>'+row[c.id]+'</td>' }).join('')
    return '<tr>'+data+'</tr>'
  }).join('')

  var template = ' <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"> <head> <!--[if gte mso 9]> <xml> <x:ExcelWorkbook> <x:ExcelWorksheets> <x:ExcelWorksheet> <x:Name>CRR Report</x:Name> <x:WorksheetOptions> <x:DisplayGridlines/> </x:WorksheetOptions> </x:ExcelWorksheet> </x:ExcelWorksheets> </x:ExcelWorkbook> </xml> <![endif]--> </head> <body> <table> <thead> <tr>'
          +header+
          '</tr> </thead> <tbody>'
          +body+ '</tbody> </table> </body> </html>';

  download(template, 'report.xls', 'data:application/vnd.ms-excel;')
}



//////////////////
// WEBPACK FOOTER
// ./~/ansergy-datatable/lib/downloadXLS.js
// module id = 79
// module chunks = 0